import React, { useState } from "react";

interface MediaItem {
    url: string;
    id?: string;
    index?: string;
    type: "image" | "video";
    altText?: string;
}

interface MediaPreviewProps {
    mediaUrls: MediaItem[];
    handleDeleteMedia: (id?: string, url?: string, idx?: number) => void;
}

const MediaPreview: React.FC<MediaPreviewProps> = ({
    mediaUrls,
    handleDeleteMedia,
}) => {
    const defaultImageUrl = "/assets/images/No_Image_Available.jpg";

    const handleImageError = (setImageSrc: React.Dispatch<React.SetStateAction<string>>, fallbackUrl: string) => {
        setImageSrc(fallbackUrl);
    };


    return (
        <>
            {mediaUrls.length > 0 && mediaUrls.map((item, idx) => {
                const [imageSrc, setImageSrc] = useState(item.url);
                return (
                    <div
                        key={`${item.url}-${idx}`}
                        className="border border-light-40 rounded-2xl p-2 sm:p-4 flex items-center gap-4 justify-between">
                        <div className="flex items-center gap-2">
                            {item.type === 'image' ? (
                                <img
                                    className="min-w-11 min-h-11 w-11 h-11 rounded-lg object-contain"
                                    src={`${imageSrc}`}
                                    alt={item.altText}
                                    onError={() => handleImageError(setImageSrc, defaultImageUrl)}
                                />
                            ) : (
                                <video
                                    className="min-w-11 min-h-11 w-11 h-11 rounded-lg object-contain"
                                    src={`${item.url}`}
                                />
                            )}
                            <span className="text-sm text-black font-normal">{item.altText}</span>
                        </div>
                        <button
                            type='button'
                            onClick={() => handleDeleteMedia(item.id, item.url)}
                            className=" w-8 h-8 min-w-8 min-h-8 rounded-full bg-primary-light flex items-center justify-center">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="12"
                                height="13"
                                viewBox="0 0 12 13"
                                fill="none"
                            >
                                <path
                                    d="M11.5 1L0.5 12M0.5 1L11.5 12"
                                    stroke="black"
                                    strokeWidth="0.7"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                            </svg>
                        </button>
                    </div>
                )
            })}
        </>
    );
};

export default MediaPreview;
